import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormBuilder, UntypedFormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../_services/login.service';
import { CustomValidator } from '../_services/customValidator';

@Component({
    selector: 'app-create-password',
    templateUrl: './create-password.component.html',
    styleUrls: ['./create-password.component.scss'],
    standalone: false
})
export class CreatePasswordComponent implements OnInit {

  /**details of user */
  userDetails: any = {
    name: "",
    email: ""
  }

  /**User has access to this page or not */
  showCreatePasswordPage: boolean = false;

  /**password of user alreay creted or not */
  passwordAlreadyCreated: boolean = false;

  /**Something went wrong */
  somethingWentWrong: boolean = false;

  urlParameter: any = {};

  emailForm: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  passwordForm: UntypedFormControl = new UntypedFormControl(null, Validators.required);
  confirmPassword: UntypedFormControl = new UntypedFormControl(null, Validators.required);

  /** Show password */
  showPassword: boolean = false;

  /** Show Confirm password*/
  showConfirmPassword: boolean = false;

  /** Waiting for response of set-password*/
  isLoadingSetpassword: boolean = false;

  constructor(private fb: UntypedFormBuilder, private activateRoute: ActivatedRoute, private loginService: LoginService, private router: Router) {

    this.urlParameter = this.activateRoute.snapshot.queryParams;
    this.userDetails.name = this.urlParameter.username || "goutam";
    this.userDetails.email = this.urlParameter.useremail || "goutam.chouhan@whitecrowdigital.in";

    this.emailForm = new UntypedFormControl(
      { value: this.userDetails.email, disabled: true }, // Prefilled and read-only email
      [Validators.required, Validators.email] // Required and valid email format
    ),

      this.passwordForm = new UntypedFormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(48),
        CustomValidator.patternValidator(/\d/, { hasNumber: true }),
        CustomValidator.patternValidator(/[A-Z]/, { hasCapitalCase: true }),
        CustomValidator.patternValidator(/[a-z]/, { hasSmallCase: true }),
        CustomValidator.patternValidator(/[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/, { hasSpecialCharacters: true }),
        CustomValidator.keywordIncludes("password", { hasKeyword: true })
      ]),

      this.confirmPassword = new UntypedFormControl('', [Validators.required])
  }


  ngOnInit() {
    let data = { agent: window.navigator.userAgent };

    this.loginService.ontheflytoken(data)
      .subscribe((res: any) => {
        if (res.message && res.message.token) {
          // save token in local storage
          sessionStorage.setItem('token', res.message.token);

          // save current time in local storage
          sessionStorage.setItem('emit', `${+new Date()}`);

          this.verifySetPasswordLink();

        } else {
          console.log('Something went wrong');
        }
      }, (err) => {
        this.somethingWentWrong = true;
      });
  }

  /**
   * Verify link of set password
   */
  verifySetPasswordLink() {
    if(!this.urlParameter.token){
      this.somethingWentWrong = true;
      return;
    }
    this.loginService.verifySetPasswordLink(this.urlParameter.token).subscribe(
      (res) => {
        this.showCreatePasswordPage = true;
      },
      (err) => {
        this.showCreatePasswordPage = false;
        if (err.status === 409) {
          this.passwordAlreadyCreated = true;
          console.log("Password already created");
        } else if (err.status == 500) {
          this.somethingWentWrong = true;
        }
      }
    )
  }

  /**
   * Create password
   */
  submitPassword() {
    this.passwordForm.markAsTouched({ onlySelf: true });
    this.confirmPassword.markAsTouched({ onlySelf: true });
    this.passwordsMatchValidator();
    if (!(this.passwordForm.errors && this.confirmPassword.errors)) {
      this.isLoadingSetpassword = true;
      this.loginService.setNewPassword({ token: this.urlParameter.token, pwd: this.passwordForm.value }).subscribe(
        (res) => {
          this.isLoadingSetpassword = false;
          this.redirectToLogin();
          this.showCreatePasswordPage = false;
        },
        (err) => {
          this.isLoadingSetpassword = false;
          if (err.status === 409) {
            this.showCreatePasswordPage = false;
          } else {
            console.log("something went wrong");
          }
        }
      )
    }
  }

  /**
   * 
   */
  redirectToLogin() {
    window.location.href = '/login'
  }

  /**
   * Used to match password and confirm password are same or not
   * @returns 
   */
  passwordsMatchValidator() {
    return (this.passwordForm?.value != null && this.passwordForm?.value === this.confirmPassword?.value) ? true : false;
  }

  /**
   * Used to check various constraints fullfill or not for form data
   * @param reason 
   */
  checkConstraints(reason: string) {
    if (reason === 'length') {
      return this.passwordForm.hasError('minlength') || this.passwordForm.hasError('maxlength') || !this.passwordForm?.value?.length;
    } else if (reason === 'hasSpecialCharacters') {
      return this.passwordForm.hasError('hasSpecialCharacters');
    } else if (reason === 'hasCapitalCase') {
      return this.passwordForm.hasError('hasCapitalCase');
    } else if (reason === 'hasSmallCase') {
      return this.passwordForm.hasError('hasSmallCase');
    } else if (reason === 'hasNumber') {
      return this.passwordForm.hasError('hasNumber');
    } else if (reason === 'hasKeyword') {
      return this.passwordForm.hasError('hasKeyword');
    } else if (reason === 'valid-password') {
      return this.passwordForm.errors && this.passwordForm.touched;
    } else if (reason === 'valid-confirm-password') {
      return !this.passwordsMatchValidator() && this.confirmPassword.touched;
    }
  }
}
